// src/components/GlobalTimer.js
import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions } from "../redux";
// Import your action creator(s)

const ONE_MINUTE_IN_MS = 60 * 1000;

function PiNetworkPriceUpdater() {
  const dispatch = useDispatch();

  useEffect(() => {
    // --- Action to dispatch every minute ---
    const dispatchAction = async () => {
      console.log("Timer fired - dispatching action(s)...");
      try {
        const response = await axios.get(
          "https://api.coingecko.com/api/v3/coins/markets",
          {
            params: {
              vs_currency: "usd",
              ids: "pi-network", // Add any other cryptos here
            },
          }
        );

        const updatedCryptos = response.data.map((crypto: any) => ({
          image: crypto.image,
          price_change_percentage_24h: crypto.price_change_percentage_24h,
          current_price: crypto.current_price,
          name: crypto.name,
        }));

        dispatch(actions.setPiCryptoPrice(updatedCryptos[0]?.current_price));
      } catch (error) {
        console.error("Error fetching crypto prices:", error);
      }
    };

    const intervalId = setInterval(dispatchAction, ONE_MINUTE_IN_MS);

    return () => {
      console.log("Cleaning up timer interval...");
      clearInterval(intervalId);
    };
  }, []);

  return null;
}

export default PiNetworkPriceUpdater;
